/** @jsxImportSource @emotion/react */

import React, { useMemo, useState } from 'react'
import { Form } from 'react-final-form'
import createDecorator from 'final-form-focus'
import { Button, Modal, Typography } from '@mui/material'
import { InputField } from 'components/Input'
import { validateVideoLink } from 'pagesNew/ResponseTests/Form/utils'
import { findOneExtensionExamSection_findOneExtensionExamSection_extensionPassage as Passage } from '__generatedTypes__/findOneExtensionExamSection'
import * as classes from './styles'
import { PassagePreview } from './PassagePreview'

const focusOnErrors = createDecorator<Passage, Partial<Passage>>()

export type PassageEditModalProps = {
  isOpen: boolean
  passage: Passage | null
  passageTitle: string
  onSubmit: (passage: Passage) => void
  onClose: () => void
}

export const PassageEditModal = ({ isOpen, passage, passageTitle, onSubmit, onClose }: PassageEditModalProps) => {
  const [isPassageExpanded, setIsPassageExpanded] = useState(false)

  const initialValues: Passage = useMemo(
    () => ({
      ...(passage as Passage),
    }),
    [passage]
  )

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div css={classes.modalContainerWrapper} onClick={onClose}>
        <div css={classes.modalContainer} onClick={(e) => e.stopPropagation()}>
          <Form
            decorators={[focusOnErrors]}
            onSubmit={onSubmit}
            initialValues={initialValues}
            render={({ handleSubmit, submitting }) => (
              <form css={classes.modalForm} onSubmit={handleSubmit} data-testid="edit-passage-modal">
                <Typography css={classes.modalTitle} variant="title2">
                  Update {passageTitle}
                </Typography>

                {passage && (
                  <PassagePreview
                    title={passageTitle}
                    passageContent={passage.content}
                    videoWalkthrough={passage.videoWalkthrough}
                    expanded={isPassageExpanded}
                    onExpandClick={() => setIsPassageExpanded((prev) => !prev)}
                    onEditClick={() => null}
                    isPassageOnly
                  />
                )}

                <InputField
                  label="Passage Walkthrough Video (Optional)"
                  name="videoWalkthrough"
                  validate={validateVideoLink}
                  placeholder="Enter Passage Walkthrough Video Link"
                  fullWidth
                />

                <Button variant="outlined" color="blue" size="large" disabled={submitting} onClick={onClose} fullWidth>
                  Cancel
                </Button>
                <Button variant="contained" type="submit" color="blue" size="large" disabled={submitting} fullWidth>
                  Save
                </Button>
              </form>
            )}
          />
        </div>
      </div>
    </Modal>
  )
}
